import * as React from 'react';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Chip, IconButton, Tooltip, Typography, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslate } from 'ra-core';
import { ApiStatus } from '../../apis/ApiStatus';
import { useListArrayInputItem } from '../../ui';
export function ApiChoiceItem(props) {
    const { record, selected, onAdd } = useListArrayInputItem();
    const classes = useStyles(props);
    const translate = useTranslate();
    return (React.createElement(ExpansionPanel, null,
        React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMoreIcon, null) },
            React.createElement(Tooltip, { title: translate('ra.action.add') },
                React.createElement("span", null,
                    React.createElement(IconButton, { "aria-label": translate('ra.action.add'), className: classes.add, disabled: selected, onClick: onAdd, color: "primary" },
                        React.createElement(AddIcon, null)))),
            React.createElement("div", { className: classes.root },
                React.createElement(Typography, null, record.name),
                React.createElement(Typography, { className: classes.version },
                    "v",
                    record.version))),
        React.createElement(ExpansionPanelDetails, null,
            React.createElement("div", { className: classes.details },
                record.tags &&
                    record.tags.map((tag, i) => (React.createElement(Chip, { key: i, label: tag, className: classes.tag }))),
                React.createElement("div", { className: classes.additionalDetails },
                    React.createElement("div", { className: classes.description }, record.description),
                    React.createElement(ApiStatus, { record: record, variant: "caption" }))))));
}
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    add: {
        marginTop: theme.spacing(-1),
    },
    version: {
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
    },
    details: {
        marginTop: theme.spacing(-2),
        marginLeft: theme.spacing(6),
        width: '100%',
    },
    additionalDetails: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
    },
    description: {
        marginTop: theme.spacing(0),
        fontSize: theme.typography.pxToRem(14),
    },
    tag: {
        marginRight: theme.spacing(1),
        height: theme.spacing(3),
    },
    status: {
        marginTop: theme.spacing(0),
        fontSize: theme.typography.pxToRem(14),
    },
}), {
    name: 'Layer7ApiChoiceItem',
});
//# sourceMappingURL=ApiChoiceItem.js.map